import React from 'react';
import { ArrowRight } from 'lucide-react';
import { DoyenBrand } from '../components/brand/DoyenBrand';

export function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <section className="min-h-screen relative bg-gradient-to-b from-white to-surface overflow-hidden">
        {/* Grid Pattern */}
        <div className="absolute inset-0 grid-pattern opacity-30" />

        {/* Content */}
        <div className="relative flex items-center justify-center min-h-screen px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center space-y-8">
              {/* Main Title */}
              <div className="animate-fade-in">
                <h1 className="text-7xl font-bold text-primary mb-4">
                  <DoyenBrand className="text-7xl" />
                </h1>
              </div>
              
              {/* Subtitle */}
              <div className="animate-fade-in animation-delay-500">
                <h2 className="text-3xl font-semibold text-primary mb-6">
                  Migrating Financial Data Shouldn't be Painful
                </h2>
              </div>

              {/* Description */}
              <div className="animate-fade-in animation-delay-1000">
                <p className="text-xl text-neutral-600 max-w-2xl mx-auto mb-8">
                  Quickly and accurately migrate your data into leading ERPs and Billing Platforms.
                </p>
              </div>

              {/* CTA Button */}
              <div className="animate-fade-in animation-delay-1500">
                <a 
                  href="mailto:info@doyen.com"
                  className="inline-flex items-center px-8 py-4 bg-secondary text-white rounded-lg text-lg font-semibold hover:bg-secondary-dark transition-colors"
                >
                  Contact Us
                  <ArrowRight className="ml-2 h-5 w-5" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}